<template>
  <div>
    <van-nav-bar :title="name"/>
    <div class="mineUpsection">
      <div class="fs">
        <div>
          <img src="../../assets/ava.png" class="mineavtar" v-if="!sAvatarUrl">
          <img :src="sAvatarUrl" class="mineavtar" v-else>
        </div>
        <div class="ml10 mineAccountZone">
          <div class="mineAccount">
            <span >{{name}}
            </span>
          </div>
          <!-- <div class="mineAudit">
            <span >{{idCard}}</span>
          </div> -->
          <div class="mineAudit2">
            <span >
              <van-tag type="primary">工作人员</van-tag>
            </span>
          </div>
        </div>
        <div class="fsac mineBtn" >
          <van-button round type="info" size="small" color="#1678ff" @click="clear" plain>
            <div class="syBtnTxt9">退出</div>
          </van-button>
        </div>
      </div>
    </div>
    <div>
      <div v-for="(item, index) in list" :key="index" class="mineCard">
        <div class="t1">
          <div>{{item.typeName}}:</div>
          <div class="tu">{{item.totalUser}}人</div>
        </div>
        <div class="fsb">
          <div class="t3">
            <div class="t4">通过</div>
            <div class="t51">{{item.auditTotalUser}}</div>
          </div>
          <div class="t3">
            <div class="t4">未审核(失联)</div>
            <div class="t52">{{item.noAuditTotalUser}}</div>
          </div>
          <div class="t3">
            <div class="t4">失败</div>
            <div class="t53">{{item.auditFailTotalUser}}</div>
          </div>
          <div class="t3">
            <div class="t4">离世</div>
            <div class="t54">{{item.diedTotalUser}}</div>
          </div>
        </div>
      </div>
    </div>
    <van-tabbar v-model="active" @change="onChange" active-color="#1F82FF" inactive-color="#999999" placeholder>
      <van-tabbar-item>
        <template #icon>
          <img src="../../assets/home.png">
        </template>
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="setting-o">
        <template #icon>
          <img src="../../assets/mine_active.png">
        </template>
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { Toast, Button, Divider, NavBar, Tag, Search, Popup, List, Tabbar, TabbarItem } from 'vant'

export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [List.name]: List
  },
  data () {
    return {
      active: 1,
      sAvatarUrl: '',
      name: '',
      phone: '',
      list: []
    }
  },
  mounted () {
    this.getUserInfo()
    this.ReportGetWorkerViewList()
  },
  methods: {
    onChange(index) {
      if (index === 0) {
        this.$router.replace('/worker')
      }
    },
    clear () {
      let key = `${this.idCard}-${this.name}`
      window.localStorage.removeItem(key)
      this.$router.replace('/index')
    },
    async getUserInfo () {
      let {success, data, info} = await this.$api.getUserInfo()
      console.log(data)
      if (success) {
        this.name = data.name
        this.phone = data.phone
        this.userType = Number(data.type)
      } else {
        Toast(info)
      }
    },
    async ReportGetWorkerViewList () {
      let {success, data, info} = await this.$api.ReportGetWorkerViewList()
      console.log(data)
      if (success) {
        this.list = data
        // this.name = data.name
        // this.phone = data.phone
        // this.userType = Number(data.type)
      } else {
        Toast(info)
      }
    }
  }
}
</script>
<style>
  .mineCard {
    border-radius: 6px;
    margin: 10px;
    padding: 15px;
    font-size: 16px;
    background: #fff;
  }

  .syBtnTxt9{
    color: #1678ff;
    width: 74px;
    letter-spacing: 1px;
    font-size:14px
  }
  .t1 {
    display: flex;
    height: 19px;
    line-height: 19px;
    font-size: 13px;
    color: #444;
    font-weight: bold;
  }
  .tu {
    font-weight: normal;
    height: 19px;
    line-height: 19px;
    color:#666;
    margin-left: 10px;
  }
  .mineUpsection {
    /* height: 90px; */
    /* width: 100%; */
    background: #fff;
    padding: 20px 15px
  }
  .passText {
    color: #3187FF;
    text-shadow: 0px 0px 1px #3187FF;
    font-size: 20px;
    height: 30px;
    line-height: 30px;
  }
  .mineavtar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }

  .mineAccountZone {
    width: 190px;
    letter-spacing: 1px;
  }
  .t4{
    margin-top: 8px;
    font-size: 13px;
    color:#444;
    height: 22px;
    line-height: 22px;
    text-align: center;
    width: 100%;
  }
  .t51{
    margin-top: 4px;
    font-size: 13px;
    color:#1F82FF;
    height: 16px;
    line-height: 16px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }
  .t52{
    margin-top: 4px;
    font-size: 13px;
    color:#F2851A;
    height: 16px;
    line-height: 16px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  } 
  .t53{
    margin-top: 4px;
    font-size: 13px;
    color:#E02A2A;
    height: 16px;
    line-height: 16px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }
  .t54{
    margin-top: 4px;
    font-size: 13px;
    color:#222222;
    height: 16px;
    line-height: 16px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }
  .mineAccount {
    height: 28px;
    line-height: 28px;
    position: relative;
    top: 5px;
    color: #333;
    font-size: 18px;
    text-shadow: 0px 0px 1px #333;

  }

  .mineAudit {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #454545;
  }

  .mineAudit2 {
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    color: #959595;
  }

  .mineBotsection {
    background: #fff;
    height: auto;
    padding: 15px;
    margin: 10px;
    margin-bottom: 0;
    border-radius: 6px;
  }

  .mine-title {
    color: #111;
    font-size: 15px !important;
    height: 42px;
    line-height: 42px;
  }

  .mineBtnTxt {
    color: black;
    width: 90px;
    letter-spacing: 1px;
    font-size: 13px;
  }
  .ctlZone {
    padding: 15px 20px;
  }
  .ctlbg {
    width: 80px;
    height: 80px;
    background-color: #298BFF;
    border-radius: 50%;
    opacity: 0.1;
    z-index: 0;
    position: relative;
    left: 18px;
  }
  .ctlIcon {
    width: 40px;
    height: 40px;
    z-index: 1;
    position: relative;
    right: 42px;
  }
  .ctltip {
    margin-top: 15px;
    color: #777;
    font-size: 12px;
    text-align: center;
  }
  .tipZone {
    padding: 10px 10px 0px 50px;
  }
  .tipbg {
    width: 50px;
    height: 50px;
    background-color: #fff;
    border-radius: 50%;
    opacity: 0.1;
    z-index: 0;
    position: relative;
  }
  .tipIcon {
    width: 25px;
    height: 25px;
    z-index: 1;
    position: relative;
    right: 15.5px;
    top: 6px
  }
  .tiptip {
    height: 20px;
    line-height: 20px;
    color: #444;
    font-size: 15px;
    text-align: left;
    text-shadow: 0px 0px 1px #333;
  }
  .tipdesc {
    height: 20px;
    line-height: 20px;
    color: #555;
    font-size: 12px;
    text-align: left;
  }
</style>